import React, {useEffect, useState} from 'react';
import {Card} from "primereact/card";
import {Button} from "primereact/button";
import {useNavigate,useSearchParams} from "react-router-dom";
import useApi from "../../../../hooks/useApi";
import {webInfo} from "../../../../utils/webInfo";
import {depots} from "../../../../utils/helper";
import TableSkeleton from "../../../../Loader/Loader";
import ErrorPresentor from "../../../../ErrorPresentor/ErrorPresentor";
import AnimalTable from "./AnimalTable";
import {TreeNode} from "primereact/treenode";
import {TreeSelect} from "primereact/treeselect";
import {InputText} from "primereact/inputtext";

const findNodeByKey = (nodes: TreeNode[], key: string): TreeNode | null => {
    for (const node of nodes) {
        if (node.key === key) return node;
        if (node.children) {
            const found = findNodeByKey(node.children, key);
            if (found) return found;
        }
    }
    return null;
};

const Animal = () => {
    const [params,setParams]:any = useSearchParams();
    const navigate = useNavigate();
    const [update,setUpdate] = useState(false)
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const {get:getProduct, loading:gploading,error} = useApi<any>();
    const {get:getCategory, loading:gcloading} = useApi<any>();
    const [products, setProducts] = useState<any>([]);
    const [categories,setCategories] = useState([]);
    const [search,setSearch] = useState('');

    const [treeData, setTreeData] = useState<TreeNode[]>([]);
    const [selectedNode, setSelectedNode] = useState<any>("");
    const onPageChange = (event: any) => {
        setPage(event.page + 1);
    }
    const sc:any = findNodeByKey(treeData, selectedNode);

    const value = sc?.key?.split("-")[1]

    const urlBuilder = (page:number,perPage:number,search:string,category:number) => {
        let url = `${webInfo.baseUrl}/api/admin/products-animal?page=${page}&per_page=${perPage}`

        if (search.trim() !== '' && category !==null && category !==undefined && search.trim() !== 'undefined' && search.trim() !== 'null'){
            url += `&search=${search}&product_animal_sub_category_id=${category}`
        }
        else if (category !==null && category !==undefined){
            url += `&product_animal_sub_category_id=${category}`
        }
        else if (search.trim() !== '' && search.trim() !== 'undefined' && search.trim() !== 'null') {
            url += `&search=${search}`;
        }

        // console.log("url after change", url)
        return url;
    }

    useEffect(() => {

        // let url = `${webInfo.baseUrl}/api/admin/products-animal?page=${page}&per_page=${perPage}`
        // if (value){
        //     url += `&product_animal_sub_category_id=${value}`
        // }
        const url =  urlBuilder(page,perPage,search,value)
        const fetchProducts = async () => {
            try {
                const res: any = await getProduct(url);
                setProducts(res.data.data);
                setTotal(res.data.total);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchProducts();
        // eslint-disable-next-line
    }, [page, perPage,update,value]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoryResponse: any = await getCategory(`${webInfo.baseUrl}/api/admin/products-animal-category`);
                const subCategoryResponse: any = await getCategory(`${webInfo.baseUrl}/api/admin/products-animal-sub-category`);
                const categories: any = categoryResponse.data.data;
                const subCategories: any = subCategoryResponse.data.data;
                const options = categories.map((item:any)=>({
                    name: item.name,
                    code: item.id,
                }));
                setCategories(options);
                const treeNodes: any = categories.map((cat:any) => {
                    const childrenNodes = subCategories
                        .filter((sub:any) => parseInt(sub.product_animal_category_id) === cat.id)
                        .map((sub:any) => ({
                            key: `sub-${sub.id}`,
                            label: sub.name,
                            data: sub.name,
                            icon: "pi pi-fw pi-tag",
                        }));
                    return {
                        key: `cat-${cat.id}`,
                        label: cat.name,
                        data: cat.name,
                        icon: "pi pi-fw pi-folder",
                        children: childrenNodes,
                    };
                });
                const code = params.get('category_code');
                if (code) {
                    const matched = findNodeByKey(treeData, code);
                    if (matched) setSelectedNode(matched.key);
                }
                setTreeData(treeNodes);
            } catch (err: any) {
                console.log(error)
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, []);

    const handleSearch = async (searchValue = search) => {
        const url = urlBuilder(1, perPage, searchValue, value);
        try {
            const res: any = await getProduct(url);
            setProducts(res.data.data);
            setTotal(res.data.total);
        } catch (err) {
            console.error("Failed to fetch products", err);
        }
    };

    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">{depots[1].name} Products</h4>
            <div className="flex align-items-center">
                <TreeSelect
                    showClear
                    value={selectedNode || null}
                    onChange={(e: any) => {
                        const value = e.value;
                        setSelectedNode(value || null);
                        const newParams = new URLSearchParams(window.location.search);
                        if (value) {
                            newParams.set("category_code", value);
                        } else {
                            newParams.delete("category_code");
                        }
                        setParams(newParams);
                        setPage(1);
                    }}
                    options={treeData}
                    className="w-full md:w-14rem mr-2"
                    placeholder={gcloading ? "Loading Category" : "Search by Category"}
                />

                <div className="relative w-full md:w-14rem mr-2">
                    <div className="p-inputgroup flex-1 w-full ">
                        <span className="p-input-icon-right w-full">
                            <InputText
                                placeholder="Search by Brand "
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full pr-5 border-noround-right"
                            />

                            {search && (
                                <i
                                    className="pi pi-times cursor-pointer"
                                    onClick={() => {
                                        setSearch("");
                                        handleSearch("");
                                    }}

                                    style={{
                                        position: "absolute",
                                        right: "1rem",
                                        top: "70%",
                                        transform: "translateY(-50%)"
                                    }}
                                />
                            )}
                        </span>

                        <Button
                            icon="pi pi-search"
                            onClick={() => handleSearch()}
                            disabled={!search}
                        />
                    </div>
                </div>
                <Button onClick={()=>navigate("/products/create?division=9")} label="Create New" icon="pi pi-plus" iconPos="right" />
            </div>
        </div>
    )

    return (
        <Card header={header}>
            {gploading ? <TableSkeleton/> : <div>
                {error ? <ErrorPresentor error={error}/> : <AnimalTable products={products} total={total} onPageChange={onPageChange} page={page} perPage={perPage} categories={categories} update={update} setUpdate={setUpdate} />}
            </div>}
        </Card>
    );
};

export default Animal;